/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JwtTokenResp } from '../models/JwtTokenResp';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DriveHistoryExcelService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 엑셀 토큰 발급
   * 엑셀 토큰 발급
   * @returns JwtTokenResp OK
   * @throws ApiError
   */
  public driveHistoryExcelDownloadToken({
    vin,
    startDate,
    endDate,
    locale = 'ko-kr',
  }: {
    vin: string,
    /**
     * 시작일자
     */
    startDate: string,
    /**
     * 종료일자
     */
    endDate: string,
    locale?: string,
  }): CancelablePromise<JwtTokenResp> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/excel/token',
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
        'locale': locale,
      },
    });
  }
  /**
   * 엑셀파일 다운로드
   * 엑셀파일 다운로드
   * @returns string OK
   * @throws ApiError
   */
  public driveHistoryExcelDownload({
    token,
  }: {
    /**
     * Download Token
     */
    token: string,
  }): CancelablePromise<Array<string>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/excel/file',
      query: {
        'token': token,
      },
    });
  }
}
